import { createAction, props } from '@ngrx/store';
import { IInsightDashboardFilter } from './insights-filters.reducer';

export const update_insights_filters = createAction('UPDATES_FILTERS', props<IInsightDashboardFilter>());